import React from "react"
import styled from "styled-components"
import { Box, Grid, Hidden, Typography } from "@material-ui/core"
import sixerLogo from "resources/logo/sixer-logo-footer.svg"
import facebookLogo from "resources/assets/facebook.svg"
import instagramLogo from "resources/assets/instagram.svg"
import youtubeLogo from "resources/assets/youtube.svg"
import twitterLogo from "resources/assets/twitter.svg"
import playstoreLogo from "resources/assets/playstore.svg"
import appstoreLogo from "resources/assets/appstore.svg"
import { bps } from "../../theme/index"
import { Link } from "gatsby"
import { useLocation } from "@reach/router"
import ArrowLeftIcon from "resources/assets/arrow-white.svg"
import DownloadDialog from "components/elements/Download-dialog"
import {
  pushClickEvent,
  pushPixelCheckoutEvent,
  pushPixelLeadEvent,
} from "analytics/manager"
import { events } from "analytics/events"
import {
  AndroidDownloadManager,
  IosDownloadManager,
} from "components/utils/download-manager"
import { isBrowser, isMobile, isIOS } from "react-device-detect"

const StyledCopyrightContainer = styled.div`
  height: auto;
  background-color: #4d29a2;
  color: #dad2ef;

  .copyright-container {
    max-width: 1280px;
    margin: 0 auto;
    padding: 56px 16px;
    ${bps.down("sm")} {
      flex-direction: column;
      padding: 0px 8px;
      text-align: center;
      justify-items: center;
      align-items: center;
    }
    ${bps.down("md")} {
      padding: 20px 24px;
    }
  }
`

const StyledLinksContainer = styled.div`
  height: auto;
  color: #fff;

  background-color: #5634a8;
  a {
    color: #fff;
    text-decoration: none;
  }

  h4 {
    font-weight: 600;
  }

  .footer {
    max-width: 1280px;
    margin: 0 auto;
    column-gap: 20px;
    padding: 56px 16px;
    ${bps.down("sm")} {
      flex-direction: column;
      padding: 16px 8px;
      text-align: center;
      justify-items: center;
      align-items: center;
    }
    ${bps.down("md")} {
      padding: 32px 24px;
    }
  }

  ${bps.down("sm")} {
    .icons {
      justify-content: center;
    }
  }

  .download-button {
    height: 50px;
    cursor: pointer;
  }
  img {
    height: 34px;
  }
  .footer-logo {
    height: 50px;
    ${bps.down("md")} {
      height: 34px;
    }
  }
  .arrow {
    height: 14px;
    margin-left: 8px;
  }
`

export default () => {
  const location = useLocation()
  const [_anchorEl, setAnchorEl] = React.useState(false)
  const [openDialogName, setOpenDialog] = React.useState(false)

  const handleClose = () => {
    setAnchorEl(false)
  }

  let showWebView = false
  if (
    location != null &&
    location.search != null &&
    location.search.includes("isMobileView")
  ) {
    showWebView = true
  }

  const openDownloadDialog = () => {
    setOpenDialog(true)
    pushClickEvent(events.android.Android_download)
    pushPixelLeadEvent()
    handleClose()
  }

  const closeDialog = () => {
    setOpenDialog(false)
  }

  const androidDownload = () => {
    pushPixelLeadEvent()
    AndroidDownloadManager(events.android.Android_download)
  }

  const iosDownload = () => {
    pushPixelCheckoutEvent()
    IosDownloadManager(events.ios.iOS_download)
  }
  return (
    !showWebView && (
      <div>
        <StyledLinksContainer>
          <Grid
            className="footer"
            container
            direction="row"
            justify="center"
            alignItems="flex-start"
          >
            <Grid item xs sm={4}>
              <img
                loading="lazy"
                src={sixerLogo}
                className="footer-logo"
                alt="Sixer logo"
              />
              <a href="https://sixergame.com"></a>
              <Box pt={2} />
              <Typography variant="h4">
                Sporta Technologies Pvt Ltd, ONE BKC, Tower A, 12th & 14th
                Floor, Unit 1201 & 1202 and 1401 & 1402, Plot C-66, G Block,
                Bandra Kurla Complex, Bandra (East), Mumbai 400 051
              </Typography>
              <Box pt={2} />
              <Link to="/contact">
                <Typography variant="h4">
                  Contact Us
                  <img
                    loading="lazy"
                    className="arrow"
                    src={ArrowLeftIcon}
                    alt="arrow icon"
                  ></img>
                </Typography>
              </Link>
              <Box pt={3} />
              <Grid
                container
                className="icons"
                direction="row"
                justify="flex-start"
                alignItems="center"
              >
                <Grid item xs>
                  <a href="https://www.instagram.com/sixergame/">
                    <img
                      loading="lazy"
                      src={instagramLogo}
                      alt="Instagram Logo"
                    />
                  </a>
                </Grid>
                <Grid item xs>
                  <a href="https://www.facebook.com/sixergame/">
                    <img
                      loading="lazy"
                      src={facebookLogo}
                      alt="Facebook logo"
                    />
                  </a>
                </Grid>
                <Grid item xs>
                  <a href="https://twitter.com/sixergame?lang=en">
                    <img loading="lazy" src={twitterLogo} alt="Twitter logo" />
                  </a>
                </Grid>
                <Grid item xs>
                  <a href="https://www.youtube.com/channel/UCii2BtGGKvTbQzTAeEzLs9Q">
                    <img loading="lazy" src={youtubeLogo} alt="Youtube logo" />{" "}
                  </a>
                </Grid>
              </Grid>
              <Box pt={2} />
            </Grid>
            <Grid item xs>
              <Box pt={1} />
              <Typography variant="h2">SIXER</Typography>
              <Box pt={2} />
              <Link to="/about">
                <Typography variant="h4">About Sixer</Typography>
              </Link>
              <Box pt={2} />
              <a
                target="_blank"
                href="https://scoring.sixergame.com/scoring-and-pricing"
                rel="noopener noreferrer"
                data-ga-link-decorator="false"
              >
                <Typography variant="h4">Scoring System</Typography>
              </a>
              <Box pt={2} />
              {/* <Link to="/ambassador">
                <Typography variant="h4">Become an Ambassador</Typography>
              </Link> */}
              <Box pt={2} />
              <Typography variant="h4">
                <Link to="/contact">Contact Us</Link>
              </Typography>
              <Box pt={2} />
              <Typography variant="h4">
                <Link to="/careers">Careers</Link>
              </Typography>
              <Box pt={3} />
            </Grid>
            <Grid item xs>
              <Box pt={1} />
              <Typography variant="h2">RESOURCES</Typography>
              <Box pt={2} />
              <Link to="/daily-insights">
                <Typography variant="h4">Daily Insights</Typography>
              </Link>
              <Box pt={2} />
              <a target="_blank" href="https://scoring.sixergame.com/faqs" rel="noopener noreferrer" data-ga-link-decorator="false">
                <Typography variant="h4">FAQs</Typography>
              </a>
              <Box pt={3} />
            </Grid>
            <Grid item xs>
              <Box pt={1} />
              <Typography variant="h2">LEGAL</Typography>
              <Box pt={2} />
              <Link to="/terms">
                <Typography variant="h4">Terms & Conditions</Typography>
              </Link>
              <Box pt={2} />
              <Link to="/privacy">
                <Typography variant="h4">Privacy Policy</Typography>
              </Link>
              <Box pt={2} />
              <Link to="/legality">
                <Typography variant="h4">Security & Legality</Typography>
              </Link>
              <Box pt={2} />
            </Grid>
            <Box pt={2} />
            <Grid
              container
              className="icons"
              direction="row"
              justify="flex-end"
              alignItems="center"
              spacing={2}
            >
              <Grid item>
                <div
                  onClick={() =>
                    isMobile ? androidDownload() : openDownloadDialog()
                  }
                >
                  <img
                    className="download-button"
                    loading="lazy"
                    src={playstoreLogo}
                    alt="Google play store logo"
                  />
                </div>
              </Grid>
              <Grid item>
                <div
                  onClick={() => (isIOS ? iosDownload() : openDownloadDialog())}
                >
                  <img
                    className="download-button"
                    loading="lazy"
                    src={appstoreLogo}
                    alt="Apple app store logo"
                  />
                </div>
              </Grid>
            </Grid>
            <Box pt={2} />
          </Grid>
          <Hidden smDown implementation="css">
            <DownloadDialog
              open={openDialogName == true}
              handleClose={closeDialog}
            />
          </Hidden>
        </StyledLinksContainer>

        <StyledCopyrightContainer>
          <Grid
            container
            className="copyright-container"
            direction="row"
            justify="space-between"
            alignItems="center"
          >
            <Grid item xs>
              <Typography variant="h6">
                Disclaimer: Unless otherwise explicitly specified, Sixer is not
                affiliated in any way to and claims no association, in any
                capacity whatsoever, with any international or national or
                domestic sports body/franchise including, but not limited to the
                International Cricket Council (ICC), the Board of Control for
                Cricket in India (BCCI) or the Indian Premier League (IPL).
              </Typography>
              <Box pt={2} />
              <Typography variant="h6">
                This game involves an element of financial risk and may be
                addictive. Please play responsibly at your own risk.
              </Typography>
              <Box pt={2} />
            </Grid>
            <Grid item xs>
              <Grid container justify="flex-end">
                <Typography variant="h6">
                  Copyright © 2017 - 2024 SIXER GAME | All rights reserved
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          {isBrowser && location.pathname === "/" && <Box my={6} />}
        </StyledCopyrightContainer>
      </div>
    )
  )
}
